import initializeAttachmentStateForSmimeAttachments from '../actions/initializeAttachmentStateForSmimeAttachments';
import { mutator } from 'satcheljs';

export default mutator(initializeAttachmentStateForSmimeAttachments, actionMessage => {
    // Move image view attachments to doc view attachments since image view is not supported for S/MIME
    const { docViewAttachments, imageViewAttachments } = actionMessage.attachmentWell;
    docViewAttachments.push(...imageViewAttachments);
    actionMessage.attachmentWell.imageViewAttachments = [];
});
